import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgBasicFurnished({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 16 16"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <path d="M12.38 4.5V1.87c0-.48-.4-.87-.88-.87H1.87C1.4 1 1 1.4 1 1.88V4.5c0 .48.4.88.88.88h9.62c.48 0 .88-.4.88-.88zm.87-1.75v3.5c0 .48-.4.88-.88.88H8c-.97 0-1.75.78-1.75 1.75v.87c-.48 0-.88.4-.88.88v3.5c0 .48.4.87.88.87H8c.48 0 .88-.4.88-.88v-3.5c0-.48-.4-.87-.88-.87v-.88h4.38A2.62 2.62 0 0015 6.25V4.5c0-.97-.78-1.75-1.75-1.75z" />
    </svg>
  );
}

SvgBasicFurnished.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgBasicFurnished.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => <SvgBasicFurnished svgRef={ref} {...props} />);
export default ForwardRef;
